<template>
  <skeleton :button="buttonLabel" :background="background" @next="$emit('next')">
    <div class="first">
      <vv-speech-bubble :title="leftTitle" :subtitle="rightTitle">
        <span v-html="firstText"></span>
      </vv-speech-bubble>
    </div>

    <vv-speech-bubble>
      <span v-html="secondText"></span>
    </vv-speech-bubble>
  </skeleton>
</template>

<script>
import { VvSpeechBubble } from '@/components/common'
import Skeleton from './TransitionSkeleton'

export default {
  name: 'SpeechTransition',
  components: { VvSpeechBubble, Skeleton },
  props: {
    buttonLabel: String,
    background: String,
    leftTitle: String,
    rightTitle: String,
    text1: String,
    text2: String
  },
  computed: {
    firstText() {
      return this.text1.split('\n').join('<br />')
    },
    secondText() {
      return this.text2.split('\n').join('<br />')
    }
  }
}
</script>

<style lang="scss" scoped>
.first {
  margin-bottom: 50px;
}
</style>
